import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleUnauthorized } from '../utils/apiHelper';
import Loader from "../components/child/Loder";
import DangerAlert from "../components/child/Alert/DengerAlert";

const useAnalyticData = (timeframe, category) => {
  const [EarningChartSeries, setEarningChartSeries] = useState([]);
  const [EarningChartOptions, setEarningChartOptions] = useState({});
  const [items, setItems] = useState({});
  const [loading, setLoading] = useState(true);
  const authToken = localStorage.getItem('authToken');
  const navigate = useNavigate();

 
    useEffect(() => {
      fetchData();
    }, [timeframe, category]);
    console.log('category...',category);
    console.log('timeframe...',timeframe);
  const fetchData = async () => {
    const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/admin-analytics-report?timePeriod=${timeframe}&storageType=${category}`;
    try {
      setLoading(true);
      const response = await fetch(API_ENDPOINT, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (response.status === 401) {
        handleUnauthorized(navigate);
        return;
      }

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const datas = await response.json();
      setItems(datas.data || {});
    } catch (error) {
      setItems({});
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!items || Object.keys(items).length === 0) return;
    const earningData = items.storageTypeChartFilter || [];
    if (timeframe === 'Weekly') {
      const earnings = earningData.map(item => item.earnings);
      const formattedDates = earningData.map(item => {
        const dateObj = new Date(item.date);
        return dateObj.toLocaleDateString('en-GB');
      });

      setEarningChartSeries([{ name: 'Earnings', data: earnings }]);
      setEarningChartOptions({
        chart: { type: 'line', toolbar: { show: false } },
        colors: ['#E283A6', '#13070C'],
        xaxis: { categories: formattedDates },
      });
    }

    else if (timeframe === 'Monthly') {
      const earnings = earningData.map(item => item.earnings);
      const formattedDates = earningData.map(item => {
        const dateObj = new Date(item.date);
        return dateObj.toLocaleDateString('en-GB', {
          day: 'numeric',
          month: 'short',
        });
      });

      setEarningChartSeries([{ name: 'Earnings', data: earnings }]);
      setEarningChartOptions({
        chart: { type: 'area', toolbar: { show: false } },
        colors: ['#E283A6', '#13070C'],
        xaxis: { categories: formattedDates },
      });
    }

    else if (timeframe === 'Yearly') {
      const earnings = earningData.map(item => item.earnings);
      const months = earningData.map(item => {
        if (item.month && typeof item.month === 'string') {
          return item.month.split(' ')[0]; // e.g., "Jan"
        }
        return 'Unknown'; // fallback label
      });

      setEarningChartSeries([{ name: 'Earnings', data: earnings }]);
      setEarningChartOptions({
        chart: { type: 'area', toolbar: { show: false } },
        colors: ['#E283A6', '#13070C'],
        xaxis: { categories: months },
      });
    }
  }, [timeframe, items]);

return {
  EarningChartSeries,
  EarningChartOptions,
  loading,
};
};

export default useAnalyticData;
